export default __webpack_public_path__ + "static/media/triangle.2290c1c7.svg";